/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_contact_success_body_bug = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your bug report was received. We'll take a look soon.`)
};

const es_contact_success_body_bug = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hemos recibido tu informe de error. Lo revisaremos pronto.`)
};

const de_contact_success_body_bug = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Fehlerbericht ist eingegangen. Wir schauen ihn uns bald an.`)
};

const nl_contact_success_body_bug = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We hebben je bugmelding ontvangen. We bekijken het binnenkort.`)
};

const fr_contact_success_body_bug = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre rapport de bug a bien été reçu. Nous y jetterons un œil bientôt.`)
};

const it_contact_success_body_bug = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abbiamo ricevuto la tua segnalazione di bug. La esamineremo presto.`)
};

const pt_br2_contact_success_body_bug = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recebemos seu relato de bug. Vamos dar uma olhada em breve.`)
};

const pt_contact_success_body_bug = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recebemos o teu relatório de erro. Vamos analisá-lo em breve.`)
};

const ja_contact_success_body_bug = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バグ報告を受け取りました。近いうちに確認します。`)
};

const zh_contact_success_body_bug = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们已收到你的 bug 反馈，会尽快查看。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const contact_success_body_bug = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.contact_success_body_bug(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("contact_success_body_bug", locale)
	if (locale === "en") return en_contact_success_body_bug(inputs)
	if (locale === "es") return es_contact_success_body_bug(inputs)
	if (locale === "de") return de_contact_success_body_bug(inputs)
	if (locale === "nl") return nl_contact_success_body_bug(inputs)
	if (locale === "fr") return fr_contact_success_body_bug(inputs)
	if (locale === "it") return it_contact_success_body_bug(inputs)
	if (locale === "pt-BR") return pt_br2_contact_success_body_bug(inputs)
	if (locale === "pt") return pt_contact_success_body_bug(inputs)
	if (locale === "ja") return ja_contact_success_body_bug(inputs)
	return zh_contact_success_body_bug(inputs)
};